import React, { useState } from "react";
import Modal from "../Modal";
import { Share2, Copy, Check } from "lucide-react";
import { generateEmojiGrid } from "../../../lib/game-helpers";
import { SHARE_TEMPLATE } from "../../../lib/constants";
import { shareGame, canNativeShare } from "../../../lib/share-game";

function ShareResultsModal({
    isOpen,
    onClose,
    isWon,
    submittedGuesses,
    gameData,
    puzzleNumber = 1,
    numMistakes = 0
}) {
    const [copied, setCopied] = useState(false);

    const emojiGrid = generateEmojiGrid(gameData, submittedGuesses);

    const shareText = SHARE_TEMPLATE.getShareText(
        puzzleNumber,
        emojiGrid,
        numMistakes
    );

    const handleShare = async () => {
        try {
            await shareGame(shareText);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error("Share failed:", error);
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(shareText);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error("Copy failed:", error);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={isWon ? "YOU WON! 🎉" : "GAME OVER"}
        >
            <div className="space-y-4">
                {/* Result message */}
                <div className="text-center">
                    {isWon ? (
                        <p className="text-sm text-slate-600">
                            {numMistakes === 0
                                ? "Perfect game! No mistakes!"
                                : `Great job! ${numMistakes} mistake${numMistakes !== 1 ? 's' : ''}.`}
                        </p>
                    ) : (
                        <p className="text-sm text-slate-600">
                            Better luck next time! The correct groups are revealed below.
                        </p>
                    )}
                </div>

                {/* Emoji grid display */}
                <div className="bg-slate-50 rounded-xl p-4">
                    <div className="emoji-grid whitespace-pre-wrap font-mono text-center text-xl leading-relaxed">
                        {emojiGrid}
                    </div>
                </div>

                {/* Share buttons */}
                <div className="flex gap-3">
                    {canNativeShare() ? (
                        <button
                            onClick={handleShare}
                            className="share-button flex-1"
                        >
                            <Share2 size={18} />
                            <span>Share Results</span>
                        </button>
                    ) : (
                        <button
                            onClick={handleCopy}
                            className="share-button flex-1"
                        >
                            {copied ? (
                                <>
                                    <Check size={18} />
                                    <span>Copied!</span>
                                </>
                            ) : (
                                <>
                                    <Copy size={18} />
                                    <span>Copy Results</span>
                                </>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export default ShareResultsModal;
